import { DropDownWithLabelModel } from "./dropDown";

export enum ClientContactTypes {
    COMPANY = "COMPANY",
    PRIVATE = "PRIVATE",
    CALL_CENTER = "CALL_CENTER"
}

export const ClientContactDropDown: DropDownWithLabelModel = {
    label: "Kontakt z klientem",
    dropDown: [
        {
            id: ClientContactTypes.COMPANY,
            displayName: "Firmowy"
        },
        {
            id: ClientContactTypes.PRIVATE,
            displayName: "Własny"
        },
        {
            id: ClientContactTypes.CALL_CENTER,
            displayName: "Call Center"
        }
    ]
};
